import React, { useState } from "react";
import Select from "react-select";
import Offcanvas from "react-bootstrap/Offcanvas";

const ItemsTabs = () => {
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);

  const handleShowAdd = (e) => {
    e.preventDefault();
    setShowAdd(true);
  };

  const handleShowEdit = (e) => {
    e.preventDefault();
    setShowEdit(true);
  };

  const handleCloseAdd = () => setShowAdd(false);
  const handleCloseEdit = () => setShowEdit(false);

  return (
    <>
      <form>
        <div className="card">
          <div className="card-body">
            <div className="row">
            <div className="col-md-12">
              <div className="ms-2">
                <label htmlFor="" className="form-label  mb-0">
                Remarks
                </label>
                <div className="icon-forms mb-3 mb-sm-0">
                  <textarea name="" id="" className="form-control"></textarea>
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default ItemsTabs
